export default __webpack_public_path__ + "static/media/Piscina.599341eb.png";